import React, { useState, useEffect } from "react"
import { Link } from "@reach/router"
import Airtable from "airtable"
import { FcDocument } from "react-icons/fc"

// UI components
import HomeHeader from "../components/HomeHeader.jsx"
import Footer from "../components/Footer.jsx"

const Documents = ({ page, project }) => {
  const [urls, setURLS] = useState([])
  const [weeks, setWeeks] = useState([])
  const [monthlyDoc, setMonthlyDoc] = useState({})

  //Obtenemos el documento mensual de la columna correspondiente
  const monthlyDocument = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base(`Obras General`)
      .select({
        filterByFormula: `{OBRA} = "${project}"`,
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          //let docs = []
          records.forEach(function (record) {
            if (record.get("NUEVA COLUMNA") !== undefined) {
              //docs.push(record.get("NUEVA COLUMNA")[0])

              //Se almacena el documento correspondiente
              setMonthlyDoc(record.get("NUEVA COLUMNA")[0])
            }
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // API Request para obtener los documentos PDF
  const documentRequest = week => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    //Hay que filtrar basado en el nombre de la columna OBRA
    // -> filterByFormula: `{OBRA} = ${props.project}`,
    base(`Semana ${week}`)
      .select({
        filterByFormula: `{OBRA} = "${project}"`,
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          let docs = []
          records.forEach(function (record) {
            if (record.get("BITACORA DE CAMPO") !== undefined) {
              docs.push(record.get("BITACORA DE CAMPO")[0])

              if (record.get("ANALISIS DE CAMPO") !== undefined) {
                docs.push(record.get("ANALISIS DE CAMPO")[0])
              } else {
                docs.push(null)
              }

              if (record.get("INDICADORES") !== undefined) {
                docs.push(record.get("INDICADORES")[0])
              } else {
                docs.push(null)
              }

              if (record.get("RESUMEN DE INDICADORES") !== undefined) {
                docs.push(record.get("RESUMEN DE INDICADORES")[0])
              } else {
                docs.push(null)
              }

              //Almacenamos el arreglo temporal en el estado de las URL
              setURLS(elems => [...elems, docs])
              setWeeks(items => [...items, week].sort())
            }
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }
  // Renderiza aquellas semanas que tengan documentos
  const req = () => {
    for (let i = 1; i <= 87; i++) documentRequest(i)
  }

  useEffect(() => {
    req()
    monthlyDocument()
  }, [])

  return (
    <>
      <HomeHeader />
      <div className="controls">
        <Link className="arrow-back" to="/kila-home-id-980615">
          &larr; Inicio
        </Link>
        <Link className="arrow-back" to={`/building/${page}`}>
          Ver Obra &rarr;
        </Link>
      </div>
      <h1 className="title-docs">{project}</h1>
      <div>
        <div className="week-title">
          {weeks.map((week, id) => (
            <p key={id}>Semana {week}</p>
          ))}
        </div>
        <ul className="docs-categories">
          <li>Bitacora de Campo</li>
          <li>Análisis de Campo</li>
          <li>Indicadores</li>
          <li>Resumen de Indicadores</li>
          <li>
            Nueva Columna
            <br />
            (Período Mensual)
          </li>
        </ul>
        <div className="monthly-doc">
          <a href={`${monthlyDoc.url}`} target="_blank">
            {monthlyDoc.url !== undefined ? (
              <FcDocument size={window.innerWidth > 500 ? 65 : 37} />
            ) : (
              <></>
            )}
          </a>
        </div>
        <div className="document-box">
          {urls.map(url =>
            url.map((elem, id) =>
              elem !== null ? (
                <div key={id} className="document-item">
                  <a href={`${elem.url}`} target="_blank">
                    <FcDocument size={window.innerWidth > 500 ? 65 : 37} />
                    <span>
                      {window.innerWidth > 500 ??
                        (elem.filename.length > 16
                          ? elem.filename.slice(0, 17).concat("...")
                          : elem.filename)}
                    </span>
                  </a>
                </div>
              ) : (
                <div key={id} className="document-item"></div>
              )
            )
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Documents
